import React from "react";
import Container from "@material-ui/core/Container";
import { ParsedRecord } from "../../types/airtable";

import Map from "./map/Map";
import "./MainPanel.scss";

export default function MainPanel({
  records
}: {
  records: ParsedRecord[];
}): JSX.Element {
  return (
    <div id="mainpanel">
      <Map records={records} />
    </div>
  );
}
